import React from "react";
import { ApplicationState } from "../store";
import { actions } from "./../store/Profile";
import { connect, ConnectedProps } from "react-redux";
import { TextInputGroupBasePhone } from "./TextInputGroupBase.Phone";
import { useLocalValidation } from "../hooks/useLocalValidation";

type ContactsPhoneProps = ConnectedProps<typeof connector> & {
  forwardedRef?: React.RefObject<HTMLInputElement>;
};

export const ContactsPhoneInput: React.FC<ContactsPhoneProps> = (props: ContactsPhoneProps) => {
  const description = props.stateDescriptions[props.state];

  useLocalValidation({
    fieldName: "phone",
    state: props.state,
    value: props.value,
    errorMessage: description,
  });

  return (
    <TextInputGroupBasePhone
      forwardedRef={props.forwardedRef}
      input={{
        onChange: props.onChange,
        helperText: description,
        hasError: props.state > 0,
        value: props.value ?? "",
        id: "phone",
        placeholderText: props.placeholderText,
        name: "phone",
        autoComplete: "phone",
      }}
      label={{
        title: props.title ?? "",
      }}
      help={{
        title: props.description?.title,
        description: props.description?.text,
      }}
    />
  );
};

const connector = connect((state: ApplicationState) => state.profile?.phone, {
  onChange: actions.customerPhoneChanged,
});

export default connector(ContactsPhoneInput);
